import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import TranslationQuotaSummary from "../../traduzioni/TranslationQuotaSummary";
import { loadTranslationQuota, translationAllowed, translationQuotaWarning } from "../../traduzioni/translationQuota";

function SubHeaderTrad({ funzAggiorna, charCount, setCharCount, titolo, setTradPermessa }) {
    const { user, getAccessTokenSilently } = useAuth0();
    const [quota, setQuota] = useState({ total: charCount, limit: null });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        setLoading(true);
        setError(false);
        setTradPermessa?.(false);
        loadTranslationQuota(getAccessTokenSilently, controller.signal)
            .then((result) => {
                if (controller.signal.aborted) return;
                setQuota(result);
                setCharCount?.(result.total);
                setTradPermessa?.(translationAllowed(result.total, result.limit));
            })
            .catch((err) => {
                if (controller.signal.aborted) return;
                console.error("Errore nel conteggio caratteri", err);
                setError(true);
                setTradPermessa?.(false);
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });
        return () => controller.abort();
    }, [getAccessTokenSilently, user?.sub, setCharCount, setTradPermessa]);

    const warning = translationQuotaWarning(quota.total, quota.limit);
    return (
        <div className={`${warning || error ? "tastoRosso" : "tastoVerde"} white flex items-center justify-between pl4 pr4`}>
            <div className="pt1 pb1"><span className="b">{titolo}</span></div>
            <TranslationQuotaSummary total={quota.total} limit={quota.limit} loading={loading} error={error} />
            {funzAggiorna && <div className="buttonInSubHeader flex items-center" onClick={funzAggiorna}><span className="material-icons f4 pr2">autorenew</span>Aggiorna</div>}
        </div>
    );
}

export default SubHeaderTrad;
